import React from 'react';

import Avatar from 'src/components/base/Avatar/Avatar';
import { Typography } from '../../Typography/Typography';
import { sanitiseHTML } from 'src/legacy/utils/helpers';
import { Color } from 'src/latest/src/types/Components';
import { NetworkStatusEnums, NetworStatus } from 'src/latest/src/types';
import { Alert } from '../../Alert';
import { useTranslation } from 'react-i18next';


type Props = {
  containerClass?: string;
  className?: string;
  therapistPic?: string;
  therapistName?: string;
  statusLabel: React.ReactNode;
  statusLabelColor?: Color; // pass a Typography color prop
  description?: string | React.ReactNode;
  networkStatus?: NetworStatus;
};

const StatusCard: React.FC<Props> = ({
  containerClass,
  className,
  therapistPic,
  therapistName,
  statusLabel,
  statusLabelColor,
  description,
  networkStatus,
}) => {
    
    const { t } = useTranslation('insuranceVerification');
    
  return (
    <div className={`card-container ${containerClass || ''} ${className || ''}`}>
      <div className="avatar-title-row d-flex align-items-center me-2">
        {therapistPic && therapistName && (
          <Avatar photoUrl={therapistPic} fullName={therapistName} size="60px" />
        )}
        <div>
          <Typography variant="size-20" color="color-2" >
            {therapistName}
          </Typography>
          <div className='d-flex'>
          {networkStatus === NetworkStatusEnums.IN_REVIEW && <Typography variant="size-26" color={statusLabelColor} weight="semi-bold"
className='me-2'>
            Network Status:
          </Typography>}
          <Typography variant="size-26" color={statusLabelColor} weight="bold">
            {statusLabel}
          </Typography>
          </div>
        </div>
      </div>

      {description && (
       <Typography variant="size-14" color="color-28" className="mt-3">
          {typeof description === 'string' ? sanitiseHTML(description) : description}
        </Typography>
      )}
      {
        networkStatus === NetworkStatusEnums.IN_REVIEW && <Alert type={'warning'} className={'justify-content-start mt-3 d-flex'} message={t('insuranceNetworkStatus.inReviewInfoAlert')} />
      }
    </div>
  );
};

export default StatusCard;
